import api from '../../schedulerApi';

const useHttpPutDeviceDailyModeConfig = () => {
    const put = async (device_id, daily_bp_id, config_id, config) => {
        try {
            const response = await api.update_device_daily_mode_config(device_id, daily_bp_id, config_id, config);
            return response;
        } catch (error) {
            console.error('Error updating device daily mode config:', error?.response?.data || error.message);
        }
    };

    return put;
};

export default useHttpPutDeviceDailyModeConfig;
